import { Component, OnInit, Input, NgZone, OnChanges, OnDestroy, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ReportService } from '../inservice/report.service';
import { CookieService } from '../_services/cookie.service';
import { ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
declare var $: any;
@Component({
  selector: 'app-reportinfo',
  templateUrl: './reportinfo.component.html',
  styleUrls: ['./reportinfo.component.css']
})
export class ReportInfoComponent implements OnInit, OnChanges, OnDestroy {
  loginInfo = "USER";
  rpts = [];
  expanded
  statusList = [];
  userid:number;
  @Input() user: any;
  @Input() hide: boolean;
  @Input() logOutFlag: number;
  @Output() info = new EventEmitter<any>();
  @Output() getLogo = new EventEmitter<boolean>();
  @ViewChild('content', { static: false }) private content;
  @ViewChild('userinfo', { static: false }) private userinfo;
  constructor(private fb: UntypedFormBuilder, private modalService: NgbModal, private router: Router, private ngZone: NgZone, private cookieService: CookieService, private reportService: ReportService,) {
    if (this.cookieService.getCookie("userID")) {
      this.loginInfo = this.cookieService.getCookie("userName"); 
      this.userid = parseInt(this.cookieService.getCookie("userID"));
    } else {
      
    }
  }
  openLogin() {
    this.modalReference = this.modalService.open(this.content, { centered: true, backdrop: 'static' });
  }
  modalReference2
  open(content) {
    this.modalReference2 = this.modalService.open(content, { centered: true, backdrop: 'static' })
  }
  modalReference3
  open2(content) {
    this.modalReference3 = this.modalService.open(content, { centered: true, backdrop: 'static' })
  }
  modalReference4;
  open3(content) {
    this.modalReference4 = this.modalService.open(content, { centered: true, backdrop: 'static' });
  }
  passwordCheck = false;
  registrationForm
  ngOnInit(): void {
    this.registrationForm = this.fb.group({
      userPhone: ['', [Validators.pattern("^[0-9]*$"), Validators.min(1000000000),]],
      password: ['', [Validators.required]],
      confirmpassword: ['', [Validators.required]],
    });
  }
  ngAfterViewInit() {
    if (!this.cookieService.getCookie("userID")) { this.openLogin(); }
  }
  ngOnChanges(changes: SimpleChanges): void {
   if ('logOutFlag' in changes) {
      
      if (this.logOutFlag) {
        this.logOut();
      }
    }
    if ('user' in changes) {//console.log(this.user)
      
      if (this.user && this.user.PROJECT_ID) {
        let inputJson = { "PROCEDURE": "getreportsforproject", "USER_ID": this.userid, "PROJECT_ID": this.user.PROJECT_ID };
        
        this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
          if (data.RESPONSE_STATUS=='N') {
            this.throwError(data)
          }else {
          this.rpts = data.RW_REPORTS;//REPORT_ID REPORT_TITLE
          }
        })
        this.getStatus(this.userid, this.user.REPORT_ID);
      }
    }
  }
  ngOnDestroy(): void {
    //document.removeEventListener('contextmenu', this.handleContextMenu);
    //this.reportService.editNotify.unsubscribe();
  }
  toLogo() {
    //this.toLogoPanel=!this.toLogoPanel; 
    this.getLogo.emit(true);
  }
  onLogout() {
    this.loginInfo = 'USER';
    let data = { 'USER_ID': null };
    //this.userId=null;
    this.cookieService.clearAll();
    //this.onLogin();
    this.info.emit(data);
    this.getLogo.emit(false);
    // this.openLogin();
    
    if (this.router.url === '/') {
      this.openLogin();
    } else {
      this.router.navigate(['/'])
    }
  }
  logOut() {
    Swal.fire({
      title: 'LOG OUT?',
      confirmButtonText: 'Logout',
      showCloseButton: true,
      showCancelButton: true,
      preConfirm: () => {
        this.onLogout();
      }
    })
  }
  updateTemplateTitle(rowData) {
    let inputJson = { "PROCEDURE": "updatetemplate", "USER_ID": this.userid, "TEMPLATE_ID": rowData.TEMPLATE_ID, "TEMPLATE_TITLE": rowData.TEMPLATE_TITLE };
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if (data.RESPONSE_STATUS=='N') {
        this.throwError(data)
      }
      
    })

  }
  updateCoverpageTitle(rowData) {
    let inputJson = { "PROCEDURE": "updatecoverpage", "USER_ID": this.userid, "COVERPAGE_ID": rowData.COVERPAGE_ID, "COVERPAGE_TITLE": rowData.TEMPLATE_TITLE };
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if (data.RESPONSE_STATUS=='N') {
        this.throwError(data)
      }
    })
  }
  modalReference: any;
  userData;
  onLogin() {
    let username = $('#username').val();
    let password = $('#password').val();;
    if (username === '' || password === '') {
      // Swal.showValidationMessage(`Username/Password empty`)
      // return;
    }
    let resultdata: any;
  
    let inputJson = { "PROCEDURE": "rwuserlogin", "USERNAME": username, "PASSWORD": password };
    let para = JSON.stringify(inputJson);
    this.reportService.univeralService(JSON.stringify(inputJson))
      .subscribe(data => {
        if (data.RESPONSE_STATUS=='N') {
          this.throwError(data)
        }else {
        if (data.USER_ID) {
          this.loginInfo = data.USER_FULL_NAME;
          this.cookieService.setCookieSession("userInfo", JSON.stringify(data));
          this.cookieService.setCookieSession("userID", data.USER_ID);
          this.cookieService.setCookieSession("userName", data.USER_FULL_NAME);
          this.cookieService.setCookieSession("r", data.COMPANY_ID + "_" + data.USER_ID);
          this.info.emit(data);
          Swal.fire({
            title: "Hello, " + data.USER_FULL_NAME,
            html: '<p style="font-size:16px; color:green">' + data.MESSAGE + '</p>',
            timer: 2000,
            showConfirmButton: false,
          })

        } else {
          Swal.fire({
            html: '<p style="font-size:16px; color:red">' + data.MESSAGE + '</p>',//'<p style="font-size:16px; color:red">Login Failed</p>',
            //timer: 3000,
            showConfirmButton: true,

          }).then((result) => {
            // this.onLogin();
            this.openLogin();
          }
          )
        }
      }
      })
    this.modalReference.close();
    return resultdata;//this.userInfo
  }
  getStatus(id1, id2) {
    let inputJson = { "PROCEDURE": "getreportstatuslist", "USER_ID": id1, "REPORT_ID": id2 };
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if (data.RESPONSE_STATUS=='N') {
        this.throwError(data)
      }else {
      this.statusList = data.RW_STATUS_LIST;
      }
    })
  }
  public changeStatus(status) {
    if(status=='Inactive'){
      Swal.fire({
        icon:'warning',
        html: '<span style="font-size:20px; font-weight:bold">Warning!</span><br>Once a report is INACTIVE, you may not change the status again. You will lose access to the report.<br>Only change a report to INACTIVE if you need to set up a new report using the same Template Identifier.',
        confirmButtonText: 'Confirm',
        showLoaderOnConfirm: true,
        showCancelButton: true,
        backdrop:false,
        preConfirm: () => {
          this.setStatus(status);							
        }
      })
    }else{
      this.setStatus(status)
    }
  }
  setStatus(status){
		let inputJson = { "PROCEDURE": "setreportstatus", "USER_ID": this.userid, "REPORT_ID": this.user.REPORT_ID, "STATUS": status };    
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
      if(response.RESPONSE_STATUS=='N'){
        
          this.throwError(response)
       
      }
    })
	}
  public getRUrl() {
    /*let inputJson1 = { "PROCEDURE": "getreporturl", "USER_ID": this.userid, "REPORT_ID": this.user.REPORT_ID };
    this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
      if (response.RESPONSE_STATUS=='N') {
        this.throwError(response)
      }else if (response.RESPONSE_STATUS == 'Y' && response.REPORT_URL && response.REPORT_URL.length > 0) {
        //this.user.REPORT_URL=response.REPORT_URL;
        window.open(response.REPORT_URL, '_blank');
      }
    })*/    
    this.getupdatedReportUrl().then(res=>{
      window.open(res, '_blank');
    })
  }
  public downloadFile2(url){
    let indexOfUrl = url.indexOf("?");
    const fileName = url.substring(url.lastIndexOf('/') + 1, indexOfUrl);
    fetch(url)
    .then(response => response.blob())
    .then(blob => {
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      URL.revokeObjectURL(link.href);
    });
  }
  public isPhotoLog() {
    return this.router.url.indexOf('/photolog/') > -1;
  }
  public copyRUrl(){
    let inputJson1 = { "PROCEDURE": "getreporturl", "USER_ID": this.userid, "REPORT_ID": this.user.REPORT_ID };
    this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
      if (response.RESPONSE_STATUS=='N') {
				this.throwError(response)
			}else {
      if (response.RESPONSE_STATUS == 'Y' && response.REPORT_URL && response.REPORT_URL.length > 0) {
        navigator.clipboard.writeText(response.REPORT_URL);
        this.user.REPORT_URL=response.REPORT_URL;
      }
    }
    })
  }
  loading=false;
  async generateWord(){
    let status=await this.checkPermission();
    if(status){
      this.loading=true;
      let url='';
      url=await this.getupdatedReportUrl();
      let result = await this.reportService.generateWord(url, '', this.userid.toString(),this.user.REPORT_ID.toString()).toPromise();
      this.loading=false;
      if((result.status=="Y")&&(result.data.length>0)){
        let url=JSON.parse(result.data).wordurl;
        this.popInfo(url);
      }else{
        Swal.fire({
          html: ' <p style="color:red; text-align:left">'+result.message+'</p>'	
        })
      }
    }
  }
  async getupdatedReportUrl():Promise<string>{
    return new Promise((resolve, reject)=>{
      let inputJson1 = { "PROCEDURE": "getreporturl", "USER_ID": this.userid, "REPORT_ID": this.user.REPORT_ID }; 
      this.reportService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
        if (response.RESPONSE_STATUS=='N') {
          this.throwError(response)
          reject('');
        } else {
          if (response.RESPONSE_STATUS == 'Y' && response.REPORT_URL && response.REPORT_URL.length > 0) {
            resolve(response.REPORT_URL);
          }
        }
      })
    })
  }
  popInfo(url){
		let msg1='Your report Word file has been generated!'
		let msg2='Get Word file URL';
		let msg3='Word file URL copied!';		
		Swal.fire({
							icon:'success',
							title: msg1,
							html: 'Would you like to download it or get a link?',
							confirmButtonText: 'Download',
							showLoaderOnConfirm: true,
							showCancelButton: true,
							cancelButtonText: msg2,							
							backdrop:false,													
						}).then((response) => {
							if (response.isConfirmed) {
								this.downloadFile(url);
							}else if (
								  response.dismiss === Swal.DismissReason.cancel
								) {
									navigator.clipboard.writeText(url);
									Swal.fire(
										msg3,									
									)
								}
						})
	}
  downloadFile(url){
		const link = document.createElement('a');
		link.setAttribute('target', '_blank');
		link.setAttribute('href', url);
		link.setAttribute('download', '');
		document.body.appendChild(link);
		link.click();
		link.remove();
	}
  async checkPermission(){
    let inputJson={"PROCEDURE":"checkuserpermission","USER_ID":this.userid,"FUNCTION_ID":51,"REPORT_ID":this.user.REPORT_ID};
		const data= await this.reportService.univeralService(JSON.stringify(inputJson)).toPromise();
			if(data.RESPONSE_STATUS=='Y'){
        if(data.USER_PERMISSION=='Y'){
          return true
        }else if(data.USER_PERMISSION=='N'){
          Swal.fire({
            icon:'info',
            text: data.MESSAGE,
          })
          return false;
        }				
			}else{
				this.throwError(data)
			}
  }
  private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			//console.log('Timeout');
      Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	}
}
